module.exports = __webpack_public_path__ + "static/fonts/Inter_24pt-Regular.e48c1217.ttf";